import classNames from 'classnames'
import { type DragEvent, useState } from 'react'

import { CenteredBlock, FilePicker, Modal } from '@/shared'
import { EToastings } from '@App/types/common'
import { onToasting } from '@App/utils'

import style from './ImageLoader.module.scss'

interface IProps {
    show: boolean
    onClose?: () => void
    currentImage: string
    onUploadImageCallback: (file: File) => void
    allowedFormats: string[]
}

export const ImageLoader = (props: IProps) => {
    const { show, onClose, currentImage, onUploadImageCallback, allowedFormats } = props
    const [drag, setDrag] = useState<boolean>(false)

    const uploadFilesExcetions = (file: File, callback: (file: File) => void) => {
        const parsedName = file.name.split('.')
        const currentFormat = parsedName[parsedName.length - 1]

        if (!allowedFormats.includes(currentFormat)) {
            onToasting({
                type: EToastings.ERROR,
                message: `Допускаются файлы с расширением ${allowedFormats.join(' ')}`
            })
            return
        }

        if (file.size > 4000000) {
            onToasting({
                type: EToastings.ERROR,
                message: `Допускаются файлы размером не выше 4Мб`
            })
            return
        }

        callback(file)
    }

    const filesDataCallback = (file: File) => uploadFilesExcetions(file, onUploadImageCallback)

    const dragStartHandler = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault()
        setDrag(true)
    }
    const dragLeaveHandler = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault()
        setDrag(false)
    }
    const onDropHandler = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault()
        const file = e.dataTransfer.files[0]
        filesDataCallback(file)
        setDrag(false)
    }

    const dragStyle = classNames(style.dragNdrop, style.drag)
    const leaveStyle = classNames(style.dragNdrop, style.leave)

    return (
        <Modal show={show} onClose={onClose}>
            <div className={style.container}>
                <div className={style.header}>
                    <span>Установка логотипа приложения</span>
                </div>
                <div className={style.loader}>
                    {drag && (
                        <CenteredBlock
                            className={dragStyle}
                            onDragStart={dragStartHandler}
                            onDragLeave={dragLeaveHandler}
                            onDragOver={dragStartHandler}
                            onDrop={onDropHandler}
                        >
                            <img
                                src={currentImage}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null
                                    currentTarget.src =
                                        'https://www.meme-arsenal.com/memes/20d600dd79c74b47a39ec029235fa3a1.jpg'
                                }}
                                alt='Изображение не работает'
                            />
                        </CenteredBlock>
                    )}
                    {!drag && (
                        <CenteredBlock
                            className={leaveStyle}
                            onDragStart={dragStartHandler}
                            onDragLeave={dragLeaveHandler}
                            onDragOver={dragStartHandler}
                            onDrop={onDropHandler}
                        >
                            <img
                                src={currentImage}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null
                                    currentTarget.src =
                                        'https://www.meme-arsenal.com/memes/20d600dd79c74b47a39ec029235fa3a1.jpg'
                                }}
                                alt='Изображение не работает'
                            />
                        </CenteredBlock>
                    )}
                    <div className={style.dragTitle}>
                        {drag && <span className={style.text}>Отпустите файл тут</span>}
                        {!drag && (
                            <>
                                <span className={style.text}>Перетащите файлы сюда или нажмите </span>
                                <FilePicker
                                    title='загрузить'
                                    className={style.fileLoader}
                                    onHandleFile={filesDataCallback}
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    )
}
